/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import InstantWinDetailCardComponent from "./instantWinDetailCard.component";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import instantWinApi from "app/api/instantWin";
import { addAlert } from "modules/notification";
import { getApiLang } from "app/feature/constants";

export default function InstantWinDetailCardContainer({ id }) {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.constant.languages);
  const uiSetting = useSelector((state) => state.setting.uiSetting);

  const [isLoading, setIsLoading] = useState(false);
  const [instantWin, setInstantWin] = useState(null);
  const [countdown, setCountdown] = useState({
    day: 0,
    hour: 0,
    min: 0,
    sec: 0,
  });

  const intervalRef = useRef(null);

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      instantWinApi
        .getInstantWinCardDetail({ id: id })
        .then((res) => {
          setInstantWin(res.data);
        })
        .catch((error) => {
          dispatch(
            addAlert({
              severity: "error",
              message: getApiLang(lang, error.code),
            })
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (instantWin) {
      let isStart = moment().isAfter(
        moment.utc(instantWin.join_open_at).local()
      );
      if (!isStart) {
        checkJoinStartCountdown(instantWin);
      } else {
        checkJoinCloseCountdown(instantWin);
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [instantWin]);

  const checkJoinStartCountdown = (instantWin) => {
    intervalRef.current = setInterval(() => {
      let tempCountdown = updateCountdown({
        targetDate: moment.utc(instantWin.join_open_at).local(),
      });
      setCountdown(tempCountdown);

      let countdownEnd =
        !tempCountdown.day &&
        !tempCountdown.hour &&
        !tempCountdown.min &&
        !tempCountdown.sec;
      if (countdownEnd && intervalRef.current) {
        clearInterval(intervalRef.current);
      }

      if (countdownEnd && instantWin.join_close_at) {
        checkJoinCloseCountdown(instantWin);
      }
    }, 1000);
  };

  const checkJoinCloseCountdown = (instantWin) => {
    if (!!instantWin.join_close_at) {
      let isJoinEnd = moment().isAfter(
        moment.utc(instantWin.join_close_at).local()
      );
      if (!isJoinEnd) {
        intervalRef.current = setInterval(() => {
          let tempCountdown = updateCountdown({
            targetDate: moment.utc(instantWin.join_close_at).local(),
          });
          setCountdown(tempCountdown);

          let countdownEnd =
            !tempCountdown.day &&
            !tempCountdown.hour &&
            !tempCountdown.min &&
            !tempCountdown.sec;
          if (countdownEnd && intervalRef.current) {
            clearInterval(intervalRef.current);
          }
        }, 1000);
      }
    }
  };

  const updateCountdown = ({ targetDate }) => {
    var seconds = Math.floor(
      moment.duration(targetDate.diff(moment())).asSeconds()
    );
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);

    return {
      day: days > 0 ? days : 0,
      hour: hours - days * 24,
      min: minutes - hours * 60,
      sec: seconds - minutes * 60,
    };
  };

  return (
    <InstantWinDetailCardComponent
      instantWin={instantWin}
      lang={lang}
      isLoading={isLoading}
      uiSetting={uiSetting}
      countdown={countdown}
    />
  );
}
